import React from 'react'

import Accumulation from '../../MarketVolatilityAccumulation/index'
import Distribution from '../../MarketVolatilityDistribution/index'

const App = props => {
  const { accumulationIntro, distributionIntro, accumulationChartIntro, distributionChartIntro } =
    props.content
  return (
    <>
      <div className='TwoColumn Grid Grid--equalHeight u-sm-flexCol u-sizeConstrained pt-break-after'>
        <div className='Grid gridAlignment u-sm-sizeFull u-sm-paddingVert2gu u-paddingVert4gu u-size1of2 u-sm-sizeFull u-sm-marginBottom3gu u-pt-paddingVert0 pt-break-between-avoid pt-break-after'>
          <Accumulation introduction={accumulationIntro} description={accumulationChartIntro} />
        </div>
        <div className='Grid gridAlignment u-sm-sizeFull u-sm-paddingVert2gu u-sm-paddingLeft0 u-paddingLeft4gu u-paddingVert4gu u-size1of2 u-sm-sizeFull u-pt-paddingVert0 u-pt-paddingHoriz0 pt-break-before'>
          <Distribution introduction={distributionIntro} description={distributionChartIntro} />
        </div>
      </div>
    </>
  )
}
export default App
